module.exports = __webpack_public_path__ + "media/images/icons/cake-428b4714a090850d517ea61c578f8c14.svg";